import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useT } from "@/lib/i18n";

const HomeSpecialties = () => {
  const t = useT();
  const specialties = [
    { title: t("home.spec.oncology.title"), body: t("home.spec.oncology.body"), to: "/oncologia", overline: "01" },
    { title: t("home.spec.fibro.title"), body: t("home.spec.fibro.body"), to: "/fibromialgia", overline: "02" },
    { title: t("home.spec.fatigue.title"), body: t("home.spec.fatigue.body"), to: "/fibromialgia", overline: "03" },
    { title: t("home.spec.anxiety.title"), body: t("home.spec.anxiety.body"), to: "/metodo-tao", overline: "04" },
  ];

  return (
    <section className="bg-sand/30 grain py-24 md:py-32" data-testid="specialties-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <Reveal className="max-w-2xl">
          <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-6">{t("home.specialties.eyebrow")}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal leading-[1.05]">
            {t("home.specialties.title1")} <span className="italic">{t("home.specialties.title2")}</span>.
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-5 md:gap-6">
          {specialties.map((s) => (
            <Reveal key={s.overline} delay={parseInt(s.overline) * 0.08}>
              <Link
                to={s.to}
                data-testid={`specialty-${s.overline}`}
                className="group block bg-ivory rounded-3xl p-8 md:p-12 border border-sand/70 hover:border-terracotta/40 hover:-translate-y-1 transition-all duration-500 h-full"
              >
                <div className="flex items-start justify-between gap-6">
                  <div>
                    <span className="text-[11px] tracking-[0.3em] text-terracotta">{s.overline}</span>
                    <h3 className="mt-3 font-serif text-3xl md:text-4xl text-charcoal">{s.title}</h3>
                    <p className="mt-4 text-charcoal/70 leading-relaxed text-[15px] max-w-md">{s.body}</p>
                  </div>
                  <ArrowRight size={20} className="text-charcoal/30 group-hover:text-terracotta group-hover:translate-x-1 transition-all flex-shrink-0 mt-2" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeSpecialties;
